"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.converter = void 0;
const common_1 = require("@finley-technologies/common");
const conversionUtils_1 = require("../../conversionUtils");
const types_1 = require("./types");
const uinode_1 = require("./uinode");
// converts intermediate records to 1 or more UI nodes.
const intermediateToUINodes = (tape) => {
    (0, common_1.finleyAssert)(uinode_1.file_waitForDataLakeTable.isIntermediateRecord(tape), `must be a ${types_1.artifactType} record`);
    const { id, artifactSlug, configuration: { table, anyFileVersion, initiateJobIfPartitionExists }, } = tape;
    const tapeNode = {
        metadata: {
            tapeBuilderNodeId: id,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: {
            artifactSlug,
            table,
        },
    };
    if (anyFileVersion) {
        tapeNode.configuration.anyFileVersion = true;
    }
    if (initiateJobIfPartitionExists) {
        tapeNode.configuration.initiateJobIfPartitionExists = true;
    }
    return {
        operationNode: null,
        tapeNode,
    };
};
// converts UI nodes to intermediate records.
// returns new record and old record ids to be replaced.
const uiNodesToIntermediate = (params) => {
    const { artifactDocumentId, node, graph } = params;
    (0, common_1.finleyAssert)(uinode_1.file_waitForDataLakeTable.isNode(node), `uiNodesToIntermediate: node is not a file_waitForDataLakeTable node: ${node.metadata.tapeBuilderNodeType}`);
    const { operationNode } = (0, conversionUtils_1.getOperationAndTapes)({
        node,
        graph,
    });
    (0, common_1.finleyAssert)(operationNode === null, 'uiNodesToIntermediate: operationNode was not null for receivable invoice');
    const { artifactSlug, table, anyFileVersion, initiateJobIfPartitionExists, } = node.configuration;
    const record = {
        id: node.metadata.tapeBuilderNodeId,
        artifactDocumentId,
        type: types_1.artifactType,
        artifactSlug,
        creditFacilitySlug: null,
        loanProductSlug: null,
        externalFilename: null,
        configuration: {
            table,
        },
    };
    if (anyFileVersion) {
        record.configuration.anyFileVersion = true;
    }
    if (initiateJobIfPartitionExists) {
        record.configuration.initiateJobIfPartitionExists = true;
    }
    return {
        record,
        operationNode,
    };
};
exports.converter = {
    artifactType: types_1.artifactType,
    nodeType: types_1.nodeType,
    intermediateToUINodes,
    uiNodesToIntermediate,
};
//# sourceMappingURL=converter.js.map